import isNavbarVisibleReducer from "./isNavbarVisible";
import setJwtTokenReducer from "./setJwtToken";
import companyReducer from "./companyReducer"
import { combineReducers} from 'redux';


const allReducer = combineReducers({
    isNavbarVisibleReducer,
    setJwtTokenReducer,
    companyReducer
})

export default allReducer;